import theme from './theme'
import { ChakraProvider } from '@chakra-ui/react'

const ChakraThemeProvider: React.FC = ({ children }) => (
  <ChakraProvider theme={theme}>{children}</ChakraProvider>
)

export default ChakraThemeProvider
